export default __webpack_public_path__ + "static/media/ic-publish.70d47f2f.svg";